import LpaTemplate from './lpaTemplate'

export default function LpaTemplateUpload ({filename, ...args}) {
  LpaTemplate.call(this, args)
  this.filename = filename
}

LpaTemplateUpload.prototype = Object.create(LpaTemplateUpload.prototype)

Object.assign(LpaTemplateUpload.prototype, {
  toApiPayload () {
    const lpaTemplate = LpaTemplate.prototype.toApiPayload.call(this)
    lpaTemplate.filename = this.filename
    return lpaTemplate
  },
})
